const uniqueAvatars = [
  "/assets/avatars/avatar-carson-darrin.png",
  "/assets/avatars/avatar-fran-perez.png",
  "/assets/avatars/avatar-jie-yan-song.png",
  "/assets/avatars/avatar-anika-visser.png",
  "/assets/avatars/avatar-miron-vitold.png",
  "/assets/avatars/avatar-penjani-inyene.png",
  "/assets/avatars/avatar-omar-darboe.png",
  "/assets/avatars/avatar-siegbert-gottfried.png",
  "/assets/avatars/avatar-iulia-albu.png",
  "/assets/avatars/avatar-nasimiyu-danai.png",
];

export const getRandomAvatar = () => {
  const randomIndex = Math.floor(Math.random() * uniqueAvatars.length);
  return uniqueAvatars[randomIndex];
};
